import QuestionMarkCircle from '../src/QuestionMarkCircle/index';
export default QuestionMarkCircle;
